import type { ITool } from '../../store/psyTools.slice';

interface QuestionToolSessionConfig {
  pool?: string[];
  maxQuestionsPerSession?: number;
}

const zingiziToolIdByName: Record<string, string> = {
  new_question: 'question',
};

export interface ZingiziSessionToolMetadata extends Record<string, unknown> {
  tools?: {
    question?: QuestionToolSessionConfig;
  };
}

export function createZingiziEnabledToolIds(activePsyTools: string[] | undefined): string[] {
  if (!activePsyTools?.length) {
    return [];
  }

  return Array.from(
    new Set(
      activePsyTools
        .map((toolName) => zingiziToolIdByName[toolName])
        .filter((toolId): toolId is string => typeof toolId === 'string' && toolId.length > 0),
    ),
  );
}

export function createZingiziSessionToolMetadata(psyTools: ITool[] | undefined): ZingiziSessionToolMetadata {
  const questionBlock = psyTools?.find((tool) => tool.name === 'new_question');
  const questionPool = questionBlock?.psy_tool_settings?.[0]?.value;

  if (!Array.isArray(questionPool) || questionPool.length === 0) {
    return {};
  }

  return {
    tools: {
      question: {
        pool: questionPool.filter((item): item is string => typeof item === 'string'),
      },
    },
  };
}
